import qualityEventsHelpers from '../quality-events.helpers';

export const CHECKOUT_PAGE_EVENTS = {
    applyCouponCode: (props: {
        couponCode: string;
        discountAmount: number;
        cartValueBefore: number;
        cartValueAfter: number;
    }): Promise<void> =>
        qualityEventsHelpers.track({
            type: 'applyCouponCode',
            extra: getExtra({
                coupon_code: props.couponCode,
                discount_amount: props.discountAmount,
                cart_value_before: props.cartValueBefore,
                cart_value_after: props.cartValueAfter
            })
        }),

    couponRejected: (props: { couponCode: string; rejectionReason: string; cartTotalValue: string }): Promise<void> =>
        qualityEventsHelpers.track({
            type: 'couponRejected',
            extra: getExtra({
                coupon_code: props.couponCode,
                rejection_reason: props.rejectionReason,
                cart_total_value: props.cartTotalValue
            })
        }),

    initiateCheckout: (props: {
        cartTotalValue: string;
        onFinish: VoidFunction;
        cartItems: CartItem[];
    }): Promise<void> =>
        qualityEventsHelpers
            .track({
                type: 'initiateCheckout',
                extra: getExtra({
                    cart_total_value: props.cartTotalValue,
                    cart_item_count: props.cartItems.length,
                    items: props.cartItems?.map((item) => ({ id: item.id, finalPrice: item.finalPrice })) ?? []
                })
            })
            .finally(props.onFinish),

    selectPaymentProvider: (props: {
        cartTotalValue: string;
        paymentProvider: string;
        paymentProviderPosition: number;
        checkoutValue: number;
    }): Promise<void> =>
        qualityEventsHelpers.track({
            type: 'selectPaymentProvider',
            extra: getExtra({
                payment_provider: props.paymentProvider,
                cart_total_value: props.cartTotalValue,
                checkout_value: props.checkoutValue,
                position: props.paymentProviderPosition
            })
        }),
    startPayment(userId: User['id'], paymentOption: string) {
        qualityEventsHelpers.track({
            type: 'startPayment',
            user_id: (userId || '').toString(),
            extra: paymentOption
        });
    },
    abandonedPayment(userId: User['id'], paymentOption: string) {
        qualityEventsHelpers.track({
            type: 'abandonedPayment',
            user_id: (userId || '').toString(),
            extra: paymentOption
        });
    },
    failedPayment(userId: User['id'], paymentOption: string) {
        qualityEventsHelpers.track({
            type: 'failedPayment',
            user_id: (userId || '').toString(),
            extra: paymentOption
        });
    }
};

const getDateAndTime = (): Record<string, string | number> => {
    const now = new Date();

    return {
        date: now.toISOString(),
        time: now.getTime()
    };
};

const getExtra = (
    extraFields: Record<
        string,
        | string
        | number
        | {
              id: number;
              finalPrice: string;
          }[]
    > = {}
): string | null => JSON.stringify({ ...getDateAndTime(), ...extraFields });
